import { isBrowser } from '~/utilities/helpers';

let injected = false;

export const loadGTM = (id) => {
    if (!isBrowser() || injected || !id) {
        return;
    }

    injected = true;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        'event': 'gtm.js'
    });

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;

    const firstScript = document.getElementsByTagName('script')[0];

    if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
    } else {
        document.head.appendChild(script);
    }
};
